declare namespace $ {

	export class $mol_icon_pin_off extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=off.view.tree.d.ts.map